import { EventEmitter } from '@angular/core';
import { UtilsService } from '../services/utils.service';
import { LanguagePipe } from './language.pipe';
import { ModalHelper } from '../components/modal/modal.helper';
var DataService = (function () {
    function DataService(_utils, _modal, _lang) {
        this._utils = _utils;
        this._modal = _modal;
        this._lang = _lang;
        this.turnUpdate = new EventEmitter();
        this.selectedTurnUpdate = new EventEmitter();
        this._token = null;
        this._turn = null;
        this._selectedTurn = null;
        this.desks = [];
        this.saveQueue = null;
        this.offices = [];
        this.onlineDesks = [];
        this.redError = false;
        this.timeExceed = false;
        this._deskInUse = false;
        this.deskInUseDeskName = "";
        this.deskInUseHostAddr = "";
        this.deskInUseOffice = "";
        this.deskInUseHour = "";
        this.deskInUseDate = "";
        this.inQueue = 0;
        this.enableRecallSupervisor = false;
        this.json_config = null;
        this.deskStopped = false;
        this.pauseModalTurn = false;
        this.lastCalls = [];
        this.turnStatusInViewer = [];
        /* Actions container for update list in plan mode or supervisor mode */
        this._actionContainer = 0;
        this.dniTranslation = "DNI del cliente";
        this.ccodeTranslation = "Código del cliente";
        this.configuration = {
            "language": "ES",
            "getTurnToInit": false,
            "redirectFirstAndLastMode": false,
            "recoverFinishTurn": false,
            "checkQueue": true,
            "secsCheckQueue": 6000,
            "activeSupervisor": false,
            "cancelTurnButton": true,
            "recoverFinishedTurn": false,
            "questSupervisorDesk": true,
            "deleteSupervisorDesk": true,
            "showCcodeInput": false,
            "showCcodeInputMode": 1,
            "fontSize": "20px",
            "actionToCall": 1,
            "noShow": "#343a40",
            "inWait": "#28a745",
            "redirect": "#dc3545",
            "finished": "#007bff",
            "cancelled": "#dc3545",
            "return": "#ffc107",
            "inAttention": "#17a2b8",
            "chatEnabled": false,
            "alertEnabled": false,
            "secsCheckChat": 10000,
            "autoResponse": this._lang.transform("received"),
            "alertMessage": this._lang.transform("alertDefaultMessage"),
            "phoneEnabled": false,
            "phoneKindId": null,
            "showQueueInfo": true,
            "showKindInfo": true,
            "finishTurnButton": false,
            "autoCheckQueues": false,
            "autoCheckQueuesTime": 5,
            "showPostponeButton": false,
            "queuedesk": false,
            "useOnlyDeskRedirection": false,
            "showViewerInfo": false,
            "showAllCallsViewer": false
        };
        /* Name of localStorage session data */
        this.sessionName = "session";
    }
    Object.defineProperty(DataService.prototype, "turn", {
        /* Store the actual turn data */
        get: function () {
            return this._turn;
        },
        set: function (value) {
            this._turn = value;
            this.turnChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "token", {
        get: function () {
            return sessionStorage.getItem(this._token) || '';
        },
        set: function (value) {
            sessionStorage.setItem(this._token, value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "deskInUse", {
        get: function () {
            return this._deskInUse;
        },
        set: function (value) {
            this._deskInUse = value;
            this._modal.show("deskDisconnectedModal");
            var self = this;
            $('#deskDisconnectedModal').on('hidden.bs.modal', function (e) {
                self.deleteStoredCredentials();
                localStorage.removeItem("office");
                localStorage.removeItem("desk");
                window.location.reload();
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "actionContainer", {
        set: function (number) {
            this.turnChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "selectedTurn", {
        /* Store the selected turn data */
        get: function () {
            return this._selectedTurn;
        },
        set: function (value) {
            this._selectedTurn = value;
            this.selectedTurnChanged();
        },
        enumerable: true,
        configurable: true
    });
    /* Store login credentials on LocalStorage */
    DataService.prototype.storeCredentials = function (credentials) {
        credentials = this._utils.toString(credentials);
        var obfuscate = this._utils.obfuscate(credentials);
        this._utils.localStorage("post", this.sessionName, obfuscate);
    };
    /* Get the store credentials */
    DataService.prototype.getStoredCredentials = function () {
        var credentials = this._utils.localStorage("get", this.sessionName);
        var deobfuscate = this._utils.deobfuscate(credentials);
        return this._utils.toJson(deobfuscate);
    };
    /* Delete the store credentials */
    DataService.prototype.deleteStoredCredentials = function () {
        this._utils.localStorage("delete", this.sessionName);
    };
    /* Check if user is logged */
    DataService.prototype.isLogged = function () {
        var session = this._utils.localStorage("get", this.sessionName);
        if (session === null || typeof session === "undefined") {
            return false;
        }
        return true;
    };
    /* Check if a turn is active */
    DataService.prototype.turnIsActive = function () {
        if (this.turn == null) {
            return false;
        }
        return true;
    };
    /* When the turn data change */
    DataService.prototype.turnChanged = function () {
        this.turnUpdate.emit(this._turn);
    };
    /* When the selected turn data change */
    DataService.prototype.selectedTurnChanged = function () {
        this.selectedTurnUpdate.emit(this._selectedTurn);
    };
    /* Close actual turn */
    DataService.prototype.closeTurn = function () {
        this.turn = null;
    };
    return DataService;
}());
export { DataService };
